import { useMutation } from '@tanstack/react-query';
import { ResolvedInvitation } from '@zond/api-interfaces';
import { AxiosError, AxiosResponse } from 'axios';
import { client } from '../../../../client';

export function useAcceptInvitation() {
  return useMutation<ResolvedInvitation, AxiosError, number>({
    mutationFn: (invitationId: number) =>
      client
        .put<ResolvedInvitation>(`/invitations/${invitationId}`, {})
        .then((res: AxiosResponse<ResolvedInvitation>) => res.data),
  });
}

export function useRejectInvitation() {
  return useMutation<ResolvedInvitation, AxiosError, number>({
    mutationFn: (invitationId: number) =>
      client
        .delete<ResolvedInvitation>(`/invitations/${invitationId}`)
        .then((res: AxiosResponse<ResolvedInvitation>) => res.data),
  });
}
